module.exports = __webpack_public_path__ + "static/assets/9cf89e804f37079eb103adff19e87e66.svg";